import React from 'react';
import '../../App.css';
import Award2 from "../../Assets/Bartending/award 2.jpg";
import Teach1 from "../../Assets/Bartending/teach1.jpg";
import Teach2 from "../../Assets/Bartending/Teach2.jpeg";
import Fire_Flair from "../../Assets/Bartending/tt4.jpeg";
import Flair from "../../Assets/Bartending/tt5.jpeg";
import Flair1 from "../../Assets/Bartending/tt7.jpeg";
import Juggling from "../../Assets/Bartending/tt6.jpeg";
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Placement from './Placement';
import Skills from './Skills';

export default function Home() 
{
  const items = 
  [
    <img style={{width:"95%", height : "auto"}} src={Award2} alt="Award" />,
    <img style={{width:"95%", height : "auto"}}  src={Teach1} alt="Teaching1" />,
     <img style={{width:"95%", height : "auto"}}  src={Flair} alt="Fire_Flair" />,
     <img style={{width:"95%", height : "auto"}}  src={Juggling} alt="Flair" />,
    <img style={{width:"95%", height : "auto"}}  src={Teach2} alt="Teaching2" />,
    <img style={{width:"95%", height : "auto"}}  src={Fire_Flair} alt="Mixology" />,
    <img style={{width:"95%", height : "auto"}}  src={Flair1} alt="Fire_Flair" />
    
  ];

  const responsive =
  {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  }   
return (
  <>
  <div className='MainimageSlider'>
      <div className='ImageSlider'>
        <AliceCarousel 
            infinite 
            autoPlayInterval="2000" 
            disableDotsControls 
            disableButtonsControls 
            items={items} 
            responsive={responsive}
            autoPlay />
        </div>
      </div>
        <Skills/>
        <Placement/>
    </>
    )
}
